import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    Sticky,
    StickyMenuText,
    StickyMenuItem,
    LikeIcon,
    Menu,
    StickyMenuLink,
    CommentIcon,
    YoutubeIcon,
    FacebookIcon,
    SaveIcon,
    ZaloIcon
} from './stickyMenuElements'
import { openFormLogin } from '../../../store/reducer/authFormSlice'
import { saveNews, removeNews } from '../../../store/reducer/userSlice'

const StickyMenu = ({news}) => {
    const [liked, setLiked] = useState(false)
    const [saved, setSaved] = useState(false)
    const { user, socket } = useSelector(state => state.user)
    const dispatch = useDispatch()

    useEffect(() => {
        setSaved(false)
        setLiked(news.likes.includes(user._id))
        setSaved(user.newsSaved?.includes(news._id))
    }, [news, user])

    const handleLikeOrDislike = e => {
        e.preventDefault()
        if(Object.keys(user).length === 0) {
            return dispatch(openFormLogin())
        }
        socket.emit("likeOrDislike", { userId: user._id, newsId: news._id })
    }
    
    const handleSaveNews = async e => {
        e.preventDefault()
        try {
            if(saved){
                await dispatch(removeNews(news._id))
            }else {
                await dispatch(saveNews(news._id))
            }
            
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Sticky>
            <Menu>
                <StickyMenuItem>
                    <StickyMenuLink onClick={handleLikeOrDislike} className={liked ? 'active mb-24':'mb-24'} title="Thích" href='/'>
                        <LikeIcon className="sticky-menu-icon" />
                        <StickyMenuText>{news.likes.length}</StickyMenuText>
                    </StickyMenuLink>
                </StickyMenuItem>
                <StickyMenuItem>
                    <StickyMenuLink className="mb-24" title="Bình luận" href='#cmtBox'>
                        <CommentIcon className="sticky-menu-icon" />
                        <StickyMenuText>{news.comments.length}</StickyMenuText>
                    </StickyMenuLink>
                </StickyMenuItem>
                <StickyMenuItem>
                    <StickyMenuLink title="Youtube" href='https://www.youtube.com/'>
                        <YoutubeIcon className="sticky-menu-icon" />
                    </StickyMenuLink>
                </StickyMenuItem>
                <StickyMenuItem>
                    <StickyMenuLink title="Facebook" target="_blank" href='https://www.facebook.com/pqhuy2312/'>
                        <FacebookIcon className="sticky-menu-icon" />
                    </StickyMenuLink>
                </StickyMenuItem>
                <StickyMenuItem>
                    <StickyMenuLink title="Zalo" href='https://zalo.me/0988486167'>
                        <ZaloIcon className="sticky-menu-icon" >Zalo</ZaloIcon>
                    </StickyMenuLink>
                </StickyMenuItem>
                <StickyMenuItem>
                    <StickyMenuLink onClick={handleSaveNews}  className={saved ? 'active mb-24':'mb-24'} title="Lưu" href='/'>
                        <SaveIcon className="sticky-menu-icon" />
                        <StickyMenuText className='hide-on-mobile-tablet'>Lưu</StickyMenuText>
                    </StickyMenuLink>
                </StickyMenuItem>
            </Menu>
            
        </Sticky>
    )
}

export default StickyMenu
